import { render, staticRenderFns } from "./MiniKaskoOrderFormSection.vue?vue&type=template&id=2b031494&scoped=true&"
import script from "./MiniKaskoOrderFormSection.vue?vue&type=script&lang=js&"
export * from "./MiniKaskoOrderFormSection.vue?vue&type=script&lang=js&"
import style0 from "./MiniKaskoOrderFormSection.vue?vue&type=style&index=0&id=2b031494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b031494",
  null
  
)

export default component.exports